import SuperAdmin from "./SuperAdmin";
export default SuperAdmin;
